import { render, staticRenderFns } from "./VFairInviteCodeDialog.vue?vue&type=template&id=7506f733&scoped=true"
import script from "./VFairInviteCodeDialog.vue?vue&type=script&lang=ts"
export * from "./VFairInviteCodeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506f733",
  null
  
)

export default component.exports